import {Mapper} from '@s-ui/domain'

export class PublishYourAdStructuredDataValueObjectSeoMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Function} deps.structuredDataVOFactory
   * */
  constructor({config, structuredDataVOFactory}) {
    super()
    this._config = config
    this._structuredDataVOFactory = structuredDataVOFactory
  }

  _getLocationUrl({location}) {
    const URL_PROTOCOL = this._config.get('URL_PROTOCOL')
    const HOST_DOMAIN = this._config.get('HOST_DOMAIN')
    const {PTA_PATH_PATTERN} = this._config.get('page')

    const url = `${URL_PROTOCOL}${HOST_DOMAIN}${PTA_PATH_PATTERN}`

    if (!location) return url

    const formatLocation = location.toLowerCase().replace(' ', '-')

    return `${url}/${formatLocation}/`
  }

  _getDynamicData({location}) {
    const pageUrl = this._getLocationUrl({location})
    const place = location || `España`

    return {pageUrl, place}
  }

  /**
   * https://schema.org/Service
   * @return {StructuredDataValueObject}
   */
  map = ({location}) => {
    const {pageUrl, place} = this._getDynamicData({location})

    const structuredData = {
      '@context': 'https://schema.org',
      '@type': 'Service',
      serviceType: 'Car Selling Service',
      provider: {
        '@type': 'Organization',
        name: 'coches.net',
        url: 'https://www.coches.net',
        logo: 'https://s.ccdn.es/images/coches/icons/logo-square-rounded-512x512.png'
      },
      url: pageUrl,
      description:
        'Plataforma para vender tu coche de forma rápida, sencilla y segura, conectando con particulares y profesionales interesados en tu vehículo.',
      offers: {
        '@type': 'Offer',
        url: pageUrl,
        priceCurrency: 'EUR',
        price: '0',
        eligibleRegion: {
          '@type': 'Place',
          name: place
        },
        itemOffered: {
          '@type': 'Service',
          serviceType: 'Car Listing',
          description:
            'Publica un anuncio con la matrícula y kilometraje del coche para rellenar automáticamente los datos.'
        }
      },
      additionalType: 'http://www.productontology.org/id/Online_car_selling',
      areaServed: {
        '@type': 'Place',
        name: place
      },
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Vender mi coche',
        itemListElement: [
          {
            '@type': 'OfferCatalog',
            name: 'Véndelo a un particular',
            itemListElement: {
              '@type': 'Service',
              serviceType: 'Private Car Selling',
              description:
                'Crea un anuncio con la matrícula y kilometraje del coche para rellenar automáticamente los datos.'
            }
          },
          {
            '@type': 'OfferCatalog',
            name: 'Véndelo a un profesional',
            itemListElement: {
              '@type': 'Service',
              serviceType: 'Professional Car Selling',
              description:
                'Recibe una oferta al instante por tu coche por parte de un profesional, sin publicar un anuncio.'
            }
          }
        ]
      },
      mainEntityOfPage: pageUrl
    }

    return this._structuredDataVOFactory(structuredData)
  }
}
